import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import WelcomeMessagesQuery, {
	type WelcomeMessagesQuery$data,
	type WelcomeMessagesQuery$variables,
} from './__generated__/WelcomeMessagesQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadWelcomeMessages(): Promise<{
	data: WelcomeMessagesQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<WelcomeMessagesQuery$data, WelcomeMessagesQuery$variables>({
		query: WelcomeMessagesQuery,
	});
}
